import React from 'react';
import PropTypes from 'prop-types';
import {action, computed, observable, reaction} from 'mobx';
import {observer, inject} from 'mobx-react';
import {browserOnly} from 'spa/Components/EnvSplit';
import {withConfig, withI18n} from 'spa/Components/Context';

@browserOnly
@inject(({
  store: {
    initialLoadComplete,
  },
}) => (
  {
    initialLoadComplete,
  }
))
@observer
@withConfig
@withI18n
class TrustPilotReview extends React.Component {
  static propTypes = {
    initialLoadComplete: PropTypes.bool,
    locale: PropTypes.string,
    linkText: PropTypes.string.isRequired,
    theme: PropTypes.oneOf(['light', 'dark']),
    type: PropTypes.string,
  }

  static defaultProps = {
    locale: 'en-GB',
    theme: 'light',
    type: 'horizontal',
  }

  UNSAFE_componentWillMount() {
    const {config, i18n} = this.context;

    this.trustpilotBusinessId = config.getValue('b2c.locale.trustpilot-business-id', i18n.umRegion);

    if (this.props.initialLoadComplete) {
      this.showWidget = true;
      this.checkForTrustPilot();
    }
  }

  componentDidMount() {
    this.baseDelay = 100;

    this.listeners = [
      reaction(
        () => this.props.initialLoadComplete,
        (initialLoadComplete) => {
          if (initialLoadComplete) {
            this.showWidget = true;
          }
        },
        {
          fireImmediately: true,
          name: 'Check if finished loading to show widget code',
        },
      ),
      reaction(
        () => this.showWidget,
        (showWidget) => {
          if (showWidget && window.Trustpilot) {
            window.Trustpilot.Modules.WidgetManagement.findAndApplyWidgets();
          }
        },
        {
          fireImmediately: true,
          delay: 100,
          name: 'Apply widget to code after showing',
        },
      ),
    ];
  }

  componentWillUnmount() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  @observable showWidget = false;

  @action('Trustpilot check')
  checkForTrustPilot() {
    if (!window.Trustpilot) {
      if (this.baseDelay < 3000) {
        this.timeout = setTimeout(this.checkForTrustPilot, this.baseDelay);
        this.baseDelay *= 2;
      }
    } else {
      clearTimeout(this.timeout);
      window.Trustpilot.Modules.WidgetManagement.findAndApplyWidgets();
    }
  }

  @computed get horizontal() {
    const {linkText, locale, theme} = this.props;
    return (
      <div
        className="trustpilot-widget"
        data-locale={locale}
        data-tags={locale.toLowerCase()}
        data-template-id="5419b6ffb0d04a076446a9af"
        data-businessunit-id={this.trustpilotBusinessId}
        data-style-height="45px"
        data-style-width="100%"
        data-theme={theme}
      >
        <a href="https://www.trustpilot.com/review/www.urban.co" target="_blank" rel="noopener noreferrer">{linkText}</a>
      </div>
    );
  }

  @computed get micro() {
    const {linkText, locale, theme} = this.props;
    return (
      <div
        className="trustpilot-widget"
        data-locale={locale}
        data-template-id="5419b732fbfb950b10de65e5"
        data-businessunit-id={this.trustpilotBusinessId}
        data-style-height="20px"
        data-style-width="100%"
        data-theme={theme}
      >
        <a href="https://www.trustpilot.com/review/www.urban.co" target="_blank" rel="noopener noreferrer">{linkText}</a>
      </div>
    );
  }

  @computed get review() {
    const {linkText, locale, theme} = this.props;
    return (
      <div
        className="trustpilot-widget"
        data-locale={locale}
        data-tags={locale.toLowerCase()}
        data-template-id="54ad5defc6454f065c28af8b"
        data-businessunit-id={this.trustpilotBusinessId}
        data-style-height="220px"
        data-style-width="100%"
        data-theme={theme}
        data-stars="5"
      >
        <a href="https://uk.trustpilot.com/review/urban.co" target="_blank" rel="noopener noreferrer">{linkText}</a>
      </div>
    );
  }

  render() {
    const {type} = this.props;

    if (!this.showWidget) {
      return null;
    }

    if (type === 'review') {
      return this.review;
    }
    if (type === 'micro') {
      return this.micro;
    }
    return this.horizontal;
  }
}

export default TrustPilotReview;



// WEBPACK FOOTER //
// ./spa/Components/TrustPilotReview.jsx